export default "__VITE_ASSET__D8Cr4DN7__"